<div class="full-width py-3 px-4" fxLayout="column" fxLayoutAlign="start start">
  <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="15px">
    <div class="full-width mb-0" fxLayout="row" fxLayoutAlign="end center">
      <button class="button-close-top" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="full-width" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="title-default">{{ header }}</div>
    </div>

    <form [formGroup]="leaseForm" class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px">
      <!--      *** CHOOSE OCCUPANCY *** -->
      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Occupancy</span>
        <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
          <mat-select class="custom-select-field-value" placeholder="Select" formControlName="occupancyType">
            <mat-option class="custom-select-field-option" [value]="OccupancyType.SINGLE">Single Lease</mat-option>
            <mat-option class="custom-select-field-option" [value]="OccupancyType.SHARED">Shared Space</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!--      *** Select retailer *** -->
      <div class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px" *ngIf="!disableRetailerSelection()">
        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
          <span class="body-3-default">Choose a retailer</span>
          <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
            <app-retailer-lookup
              [offeringUuid]="offering.offeringUuid"
              (retailerSelected)="selectRetailer($event)"
              [options]="retailerLookupOptions()"
              [required]="true">
            </app-retailer-lookup>
            <mat-error class="link-error">Please select a retailer</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Choose a lease period</span>
        <mat-form-field class="custom-date-picker" appearance="outline" style="width: 100%;">
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Custom" formControlName="startDate" />
            <input matEndDate formControlName="endDate"/>
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker">
            <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
          </mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>

      <div *ngIf="!this.edit" class="full-width" fxLayout="column" fxLayoutGap="7px">
        <span class="body-3-default">Choose an available space</span>
        <table mat-table class="custom-table" matSort style="width: 550px"
               [dataSource]="dataSource">
          <ng-container matColumnDef="table-label">
            <th *matHeaderCellDef [attr.colspan]="displayedColumns.length" class="custom-table-label"
                mat-header-cell></th>
          </ng-container>

          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell class="custom-table-cell" *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()" color="primary"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell class="custom-table-cell btn-cursor"
                matTooltip="Copy to clipboard" [cdkCopyToClipboard]="element.districtSpaceId"
                *matCellDef="let element"> {{element.districtSpaceId}} </td>
          </ng-container>

          <ng-container matColumnDef="spaceName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{utils.displayString(element.spaceName, 20)}} </td>
          </ng-container>

          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Size </th>
            <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.spaceSize}} m<sup>2</sup> </td>
          </ng-container>

          <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
          <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row class="custom-table-row" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator #paginator class="custom-paginator"
                       [length]="dataSource ? dataSource.data.length : 0"
                       [hidePageSize]="true"
                       [pageSize]="5"></mat-paginator>
      </div>

    </form>

  </div>

  <div class="full-width" fxLayout="row" fxLayoutAlign="end center" fxFlexOffset="15px">
    <button class="button-primary" mat-flat-button (click)="submitLease()" [disabled]="loader.loading$ | async">
      <mat-icon>check</mat-icon>
      <div class="button-text">Save Changes</div>
    </button>
  </div>

</div>

